const configMember = {
    all: {
        listLayout: 'OrderListDefaultLayout',
        paginationLayout: 'PaginationtDefaultLayout',
        filterLayout: 'OrderFilterDefaultLayout',
        listApiParamSet: {
            ip: 1,
        },
        paginationType: 'pagination',
        pageRow: 10,

    }
}

export default {
    methods: {
        returnMemberConfig(type) {
            return configMember[type];
        }
    },
    filterConfig: {
        ni: {
            type: 'query',
            classname: 'searchInput',
        },
        mid: {
            type: 'query',
            classname: 'searchInput',
        },
        na: {
            type: 'query',
            classname: 'searchInput',
        },
        oid: {
            type: 'query',
            classname: 'searchInput',
        },
        cr: {
            type: 'between',
            classname: 'filterDate',
        },
    }
}